/* Neu Appliance Outlet — live Google review numbers.
   Single source of truth for every rating value on the site. Reads the live rating + review count
   that the Elfsight Google Reviews widget injects into the page and writes them into every
   [data-neu-rating] / [data-neu-review-count] hook, and keeps the LocalBusiness schema in sync.
   Pages without the widget (PDP, collections, About) fall back to the last-known-good numbers below,
   so nothing ever shows a stale/contradicting figure. */
(function () {
  if (window.__neuReviewsSync) return;
  window.__neuReviewsSync = true;

  // Last-known-good Google numbers. The homepage overrides these live from Elfsight; bump these
  // if the widget is ever removed so the non-homepage figures stay current.
  var FALLBACK = { rating: '4.9', count: 1198 };

  function fmt(n) { return Number(n).toLocaleString('en-US'); }
  function each(sel, fn) { var n = document.querySelectorAll(sel); for (var i = 0; i < n.length; i++) fn(n[i]); }
  function safeParse(s) { try { return JSON.parse(s); } catch (e) { return null; } }

  // Depth-first search for an aggregateRating anywhere in a parsed JSON-LD object.
  function findAgg(obj) {
    if (!obj || typeof obj !== 'object') return null;
    var a = obj.aggregateRating;
    if (a && a.ratingValue != null) {
      var c = a.ratingCount != null ? a.ratingCount : a.reviewCount;
      if (c != null) return { rating: String(a.ratingValue), count: parseInt(c, 10) };
    }
    for (var k in obj) { if (obj[k] && typeof obj[k] === 'object') { var r = findAgg(obj[k]); if (r) return r; } }
    return null;
  }

  // Pull the live numbers the Elfsight widget injects (as JSON-LD, or failing that, from its text).
  function readElfsight() {
    var scopes = document.querySelectorAll('[class*="elfsight-sapp-"]');
    for (var i = 0; i < scopes.length; i++) {
      var scope = scopes[i];
      var scripts = scope.querySelectorAll('script[type="application/ld+json"]');
      for (var j = 0; j < scripts.length; j++) {
        var ar = findAgg(safeParse(scripts[j].textContent));
        if (ar && ar.count) return ar;
      }
      var t = scope.textContent || '';
      var rv = t.match(/"ratingValue"\s*:\s*"?([\d.]+)/);
      var rc = t.match(/"(?:rating|review)Count"\s*:\s*"?(\d+)/);
      if (rv && rc) return { rating: rv[1], count: parseInt(rc[1], 10) };
    }
    return null;
  }

  function apply(stats) {
    var rating = String(stats.rating);
    var count = parseInt(String(stats.count).replace(/[^\d]/g, ''), 10);
    if (!count) return;
    var countTxt = fmt(count);
    each('[data-neu-rating]', function (el) { el.textContent = rating; });
    each('[data-neu-review-count]', function (el) { el.textContent = countTxt; });
    // Keep the store's LocalBusiness structured data consistent with what the page shows.
    each('script[type="application/ld+json"]', function (s) {
      if (s.closest('[class*="elfsight-sapp-"]')) return; // never rewrite Elfsight's own node
      var raw = s.textContent;
      if (raw.indexOf('aggregateRating') < 0) return;
      var updated = raw
        .replace(/("ratingValue"\s*:\s*")[\d.]+(")/, '$1' + rating + '$2')
        .replace(/("(?:review|rating)Count"\s*:\s*")\d+(")/, '$1' + count + '$2');
      if (updated !== raw) s.textContent = updated;
    });
  }

  function run() {
    apply(FALLBACK); // instant, consistent baseline on every page
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var live = readElfsight();
      if (live && live.count) { apply(live); clearInterval(iv); }
      else if (tries > 40) clearInterval(iv); // ~20s; widget not on this page
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
